export default __webpack_public_path__ + "static/media/studios.3ae3ad5c.PNG";